import React, { useState, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Hero from '../components/HeroAI';
import Inspection3D from '../components/Inspection3D';
import HowItWorks from '../components/HowItWorks';
import Services from '../components/Services';
import ComparisonSection from '../components/ComparisonSection';
import FinancialServices from '../components/FinancialServices';
import OwnershipEcosystem from '../components/OwnershipEcosystem';
import CarServiceShowcase from '../components/CarServiceShowcase';
import Trust from '../components/Trust';
import WarrantyShowcase from '../components/WarrantyShowcase';
import Testimonials from '../components/Testimonials';
import Benefits from '../components/Benefits';
import FAQ from '../components/FAQ';
import Footer from '../components/Footer';
import LoanComparisonModal from '../components/LoanComparisonModal';
import InspectionPackages from '../components/InspectionPackages';
import WhatsAppButton from '../components/WhatsAppButton';
import B2BBanner from '../components/B2BBanner';
import { Toaster } from '../components/ui/sonner';

const Home = () => {
  const navigate = useNavigate();
  const { countryCode } = useParams();
  const [isLoanModalOpen, setIsLoanModalOpen] = useState(false);
  const [isPackagesOpen, setIsPackagesOpen] = useState(false);

  const openBookingFlow = useCallback(() => setIsPackagesOpen(true), []);

  const resolvedCountryCode =
    typeof countryCode === 'string' && /^[A-Za-z]{2}$/.test(countryCode)
      ? countryCode.toUpperCase()
      : 'IN';

  return (
    <div className="min-h-screen bg-white">
      <B2BBanner />
      <Navbar
        onBookInspection={openBookingFlow}
        onViewSampleReport={() => navigate('/sample-report')}
      />
      <Hero
        onBookInspection={openBookingFlow}
        onViewSampleReport={() => navigate('/sample-report')}
      />

      {/* 0. Interactive 3D inspection walkthrough — sits directly under Hero. */}
      <Inspection3D />

      {/* 1. Pricing reveal — three product cards, exposed in the first scroll. */}
      <Services
        onCompareLoan={() => setIsLoanModalOpen(true)}
        onBookInspection={openBookingFlow}
      />

      {/* 2. The knockout differentiator — ₹50,000 savings story.
          Lifts both customer conversion AND investor read of the business model. */}
      <OwnershipEcosystem onApplyLoan={() => setIsLoanModalOpen(true)} />

      {/* 3-5. Product deep dives, clustered so users see the full surface area
          before we ask for trust signals or process explanations. */}
      <WarrantyShowcase />
      <CarServiceShowcase />
      <FinancialServices onCompareLoan={() => setIsLoanModalOpen(true)} />

      {/* 6. Comparison validates the savings claim made in OwnershipEcosystem. */}
      <ComparisonSection />

      {/* 7-8. Trust + social proof, mid-funnel where intent peaks. */}
      <Trust />
      <Testimonials />

      {/* 9. Now they're convinced — show the booking process. */}
      <HowItWorks />

      {/* 11. Final reinforcement before FAQ. */}
      <Benefits onBookInspection={openBookingFlow} />

      <FAQ />
      <Footer onBookInspection={openBookingFlow} />

      <LoanComparisonModal
        isOpen={isLoanModalOpen}
        onClose={() => setIsLoanModalOpen(false)}
      />
      <InspectionPackages
        isOpen={isPackagesOpen}
        onClose={() => setIsPackagesOpen(false)}
        countryCode={resolvedCountryCode}
      />

      <WhatsAppButton />
      <Toaster />
    </div>
  );
};

export default Home;
